import React from "react";
import { useTranslation } from "react-i18next";
import { FaCheckCircle, FaTimes } from "react-icons/fa";
import "./SubscriptionThankYouModal.css";

interface SubscriptionThankYouModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const SubscriptionThankYouModal: React.FC<SubscriptionThankYouModalProps> = ({
  isOpen,
  onClose,
}) => {
  const { t } = useTranslation(["common"]);

  if (!isOpen) return null;

  const handleContinue = () => {
    onClose();
  };

  return (
    <div className="thank-you-modal-overlay">
      <div className="thank-you-modal">
        <button
          className="thank-you-modal-close"
          onClick={onClose}
          aria-label={t("common:actions.close")}
        >
          <FaTimes />
        </button>

        <div className="thank-you-modal-header">
          <div className="thank-you-icon">
            <FaCheckCircle />
          </div>
          <h2>{t("common:subscription.thankYou.welcomePremium")}</h2>
          <p>{t("common:subscription.thankYou.thankYouMessage")}</p>
        </div>

        <div className="thank-you-features">
          <h3>{t("common:subscription.thankYou.accessTo")}</h3>
          <div className="feature-list">
            <div className="feature-item">
              <FaCheckCircle className="feature-check" />
              <span>{t("common:subscription.features.unlimitedSearches")}</span>
            </div>
            <div className="feature-item">
              <FaCheckCircle className="feature-check" />
              <span>{t("common:subscription.features.aiMatching")}</span>
            </div>
            <div className="feature-item">
              <FaCheckCircle className="feature-check" />
              <span>{t("common:subscription.features.emailAutomation")}</span>
            </div>
            <div className="feature-item">
              <FaCheckCircle className="feature-check" />
              <span>{t("common:subscription.features.prioritySupport")}</span>
            </div>
          </div>
        </div>

        <div className="thank-you-modal-actions">
          <button className="btn-primary btn-continue" onClick={handleContinue}>
            {t("common:subscription.thankYou.continueToDashboard")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionThankYouModal;
